import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Breadcrumb, Tabs, Button } from "antd";
import Main from "../../components/layout/Main";
import BreadcrumbArrow from "../../assets/images/breadcrumb-image-arrow.svg";
import GamesImage from "../../assets/images/games-image.jpg";
import CommonBreadcrumb from "../../components/BreadCrumb";
import { useTournament } from "../../context/TournamentContext";
import { ImageNotAvailable } from "../../constants/urls";

const { TabPane } = Tabs;

const GamesIndex = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("solo");
  const [activeMode, setActiveMode] = useState("All");
  const [categories, setCategories] = useState(["All"]);
  const [allGames, setAllGames] = useState([]);
  const [gamesByCategory, setGamesByCategory] = useState({});
  const { loadGames } = useTournament();
  const location = useLocation();

  // ----------   handlers   -----------
  const fetchGames = async () => {
    setCategories(["All"]);
    setGamesByCategory({});
    const result = await loadGames({ mode: activeTab });
    if (result.status === 200) {
      const categoriesData = await result.data.data.categories;
      setAllGames(result.data.data.uncategorizedGames);
      const categoriesNames = Object.keys(categoriesData).filter(
        (category) => category !== "uncategorizedGames"
      );
      setCategories((prev) => [...new Set([...prev, ...categoriesNames])]);
      setGamesByCategory(categoriesData);
    }
  };

  const filteredGames =
    activeMode === "All" ? allGames || [] : gamesByCategory?.[activeMode] || [];

  const handleNavigate = (gameName) => {
    // console.log("game name--->", gameName);
    const lastUrl = location.pathname;
    navigate(`${lastUrl}/${gameName}`);
  };
  // ---------- use effects ----------
  useEffect(() => {
    fetchGames();
  }, [activeTab]);
  return (
    <Main>
      <CommonBreadcrumb
        items={[{ title: "Home", url: "/home" }, { title: "Games" }]}
      />

      <div className="games-versoin-name-section">
        <div className="games-versoin-name-header">
          <div className="orange-header">Games</div>
        </div>

        <div className="games-tabs">
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            className="custom-tabs"
          >
            <TabPane tab="Solo" key="solo" />
            <TabPane tab="Multiplayer" key="multiplayer" />
          </Tabs>
        </div>

        <div className="game-modes-filter">
          {categories?.map((mode) => (
            <Button
              key={mode}
              type={activeMode === mode ? "primary" : "default"}
              onClick={() => setActiveMode(mode)}
              className="mode-filter-btn"
            >
              {mode}
            </Button>
          ))}
        </div>

        <div className="main-grid-new">
          {filteredGames?.map((game, index) => {
            return (
              <div
                key={game?._id || index}
                className="game-card"
                onClick={() => handleNavigate(game?.game?.name)}
              >
                <img
                  src={game?.game?.image || ImageNotAvailable}
                  alt={game?.game?.name || "Game"}
                  className="game-image"
                />
              </div>
            );
          })}
        </div>
        {activeTab === "private" && (
          <div className="create-private-tumanet-button">
            {/* <Button className="private-tunament-button Fill-button" onClick={() => navigate("/create")} >
              Create  
            </Button> */}
          </div>
        )}
      </div>
    </Main>
  );
};

export default GamesIndex;
